<template>
    <app-data-table
        :fields="fields"
        :items="data"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="actions" slot-scope="{ item }">
            <nobr>
                <b-btn variant="primary" size="sm" @click="onEdit(item)">
                    <i class="fa fa-edit"></i>
                </b-btn>
                <b-btn variant="danger" size="sm" @click="onDelete(item)">
                    <i class="fa fa-trash"></i>
                </b-btn>
            </nobr>
        </template>
    </app-data-table>
</template>
<script>
export default {
    data() {
        return {
            fields: [
                {
                    key: 'name',
                    label: 'Nombre',
                    filter: true,
                },
                {
                    key: 'item_type.name',
                    label: 'Tipo de herramienta',
                    filter: true,
                },
                {
                    key: 'description',
                    label: 'Descripción',
                    filter: true,
                },
                {
                    key: 'slug',
                    label: 'Slug',
                    filter: true,
                },
                {
                    key: 'actions',
                    label: 'Acciones',
                },
            ],
        }
    },
    props: {
        data: {
            type: [Object, Array],
            required: true,
        },
        onEdit: {
            type: Function,
            required: true,
        },
        onDelete: {
            type: Function,
            required: true,
        },
        onChangePage: {
            type: Function,
            required: true,
        },
    },
    methods: {
        onSort(ctx) {
            this.$emit('sort', ctx)
        },
    },
}
</script>